(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(50680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Custom404 = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            color: "#8991AD",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100vh",
            margin: "0 10vw",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                style: {
                    marginBottom: "2rem"
                },
                children: "404 | no ultra sound money here"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "cursor-pointer text-slateus-200 active:brightness-90",
                href: "https://ultrasound.money/",
                rel: "noreferrer",
                target: "_blank",
                style: {
                    color: "#B5BDDB",
                    marginLeft: "0.5rem",
                    textDecorationLine: "underline"
                },
                children: "ultrasound.money"
            })
        ]
    });
/* harmony default export */ __webpack_exports__["default"] = (Custom404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);